import React from "react";
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import errorImage from "assets/error.avif";

const Fallback = ({ error, resetErrorBoundary }) => {
  let navigate;
  try {
    navigate = useNavigate();
  } catch {}

  const goHome = () => {
    if (navigate) navigate("/");
    else location.href = "/";
  };
  return (
    <Container className="d-flex align-items-center justify-content-center h-100vh w-100vw">
      <Row className="text-center text-sm-start">
        <Col xs={12} md={6}>
          <Image src={errorImage} width="100%" />
        </Col>
        <Col xs={12} md={6}>
          <h1 className="text-secondary mb-5">
            We're sorry, something went wrong...
          </h1>
          <h6>
            Please provide the following error message to the support staff to
            prevent the error from happening again.
          </h6>
          <p className="text-muted  border p-1">{error.message}</p>
          <Container fluid className="d-flex justify-content-evenly my-5">
            <Button variant="warning" onClick={resetErrorBoundary}>
              Try Again
            </Button>
            <Button variant="success" onClick={goHome}>
              Go Home
            </Button>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default Fallback;
